import { render, staticRenderFns } from "./abilities.vue?vue&type=template&id=63825ae3"
import script from "./abilities.vue?vue&type=script&lang=js"
export * from "./abilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports